<template>
  <q-input
    hide-underline
    ref="input"
    class="placeholder-italic"
    v-model="inputValue"
    :placeholder="placeholder"
    :readonly="readonly"
    @blur="handleSubmitNewValue"
    @click="handleInputClick"
    @keydown.enter="handleSubmitNewValue"
    @keydown.esc="handleCancelEdit"
  />
</template>

<script>
  export default {
    props: {
      value: {
        required: true
      },

      placeholder: {
        type: String
      },

      readonly: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        inputValue: this.value,
        selected: false
      }
    },

    methods: {
      handleInputClick () {
        this.$emit('click')

        if (!this.selected && !this.readonly) {
          this.$nextTick(() => {
            this.$refs.input.select()

            this.selected = true
          })
        }
      },

      handleSubmitNewValue () {
        this.selected = false

        if (this.value === this.inputValue) {
          return
        }

        this.$emit('save', this.inputValue)
      },

      handleCancelEdit () {
        this.$refs.input.blur()

        this.inputValue = this.value
      }
    }
  }
</script>
